<template>
  <button class="h-full small-p hover:bg-dropdown hover:text-white px-1.5 flex items-center cursor-pointer">
    <slot name="text" />
  </button>
</template>
